// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/common/rem'
import "../static/common/http";
import { download, channelCount, isWechart, fixScroll, getClientVersion } from "./utils/common"
import { post, get } from "../static/common/http";
Vue.config.productionTip = false
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$download = download
Vue.prototype.$isWechart = isWechart
Vue.prototype.$sendChannelCount = channelCount
Vue.prototype.$getClientVersion = getClientVersion
Vue.prototype.$fixScroll = fixScroll

Vue.mixin({
  created() {
  },
  computed: {
    getImgCodeUrl() {
      return process.env.BASE_APP_API + '/v1/vc/retrive?k='
    }
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js